import { toast } from "sonner";
import type { ReactNode } from "react";


type ToastMessage = string | number;

interface PromiseToastMessages {
    loading: ToastMessage;
    success: ToastMessage;
    error: ToastMessage;
}

interface CustomToastOptions {
    title?: string;
    description?: string;
    color?: "success" | "error" | "warning" | "info";
    icon?: ReactNode;
    duration?: number;
}

export const Toast = {
    success: (message: ToastMessage) => toast.success(String(message)),
    error: (message: ToastMessage) => toast.error(String(message)),
    info: (message: ToastMessage) => toast.info(String(message)),
    warning: (message: ToastMessage) => toast.warning(String(message)),
    loading: (message: ToastMessage) => toast.loading(String(message)),

    promise: <T>(promise: Promise<T>, messages: PromiseToastMessages) =>
        toast.promise(promise, {
            loading: String(messages.loading),
            success: String(messages.success),
            error: String(messages.error),
        }),

    // Uses dynamic import so no component reference exists in this TS file
    custom: async ({ title, description, icon, color = "info", duration = 3000 }: CustomToastOptions) => {
        const mod = await import("@/components/common/RenderCustomToast");
        const Renderer = mod.RenderCustomToast;

        return toast.custom(
            () => (
                // Now JSX is inside a TSX file — NOT inside toast.ts
                Renderer({ title, description, color, icon })
            ),
            { duration }
        );
    },
};
